<template>
  <div class="boxbgcolor api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AllTree v-on:handleTreeClick="handleTreeClick"></AllTree>
    </div>
    <div class="right content-right configure-right">
      <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="invoiceConfigure">
        <el-form-item label="电子发票服务商" prop="serverProvider">
          <el-select v-model="invoiceConfigure.serverProvider" clearable placeholder="请选择">
            <el-option
              v-for="item in invoicingServerData"
              :key="item.value"
              :label="item.labelZhCh"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票地址" prop="serverProviderUrl">
          <el-input v-model="invoiceConfigure.serverProviderUrl" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <!-- <el-form-item label="税号" prop="taxId">
          <el-input v-model="invoiceConfigure.taxId" @focus="isParkingIdEmpty" ></el-input>
        </el-form-item>-->
        <el-form-item label="人员代码" prop="personnelCode">
          <el-input v-model="invoiceConfigure.personnelCode" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="key" prop="keyCode">
          <el-input v-model="invoiceConfigure.keyCode" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="销售方名称" prop="sellerName">
          <el-input v-model="invoiceConfigure.sellerName" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="销售方税号" prop="sellerTaxpayerIdentifyNumber">
          <el-input
            v-model="invoiceConfigure.sellerTaxpayerIdentifyNumber"
            @focus="isParkingIdEmpty"
          ></el-input>
        </el-form-item>
        <el-form-item label="销售方地址电话" prop="sellerAddressPhone">
          <el-input v-model="invoiceConfigure.sellerAddressPhone" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="销售方开户行" prop="sellerBankAccount">
          <el-input v-model="invoiceConfigure.sellerBankAccount" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
        <el-form-item label="劳务名称" prop="productServiceName">
          <el-input v-model="invoiceConfigure.productServiceName" @focus="isParkingIdEmpty"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit">
        <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  requestInvoicingServer,
  invoiceConfigureOne,
  invoiceConfigureAddOrEdit,
  invoiceConfigureAddOr,
} from "@/api/url";

import AllTree from "@/page/commons/allTree";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      // allServiceProviderData:[{label:'领航',value:'领航'},{label:'百望',value:'百望'}],
      invoiceConfigure: {
        id: "",
        serverProvider: "",
        serverProviderUrl: "",
        personnelCode: "",
        keyCode: "",
        sellerName: "",
        sellerTaxpayerIdentifyNumber: "",
        sellerAddressPhone: "",
        sellerBankAccount: "",
        productServiceName: "",
      },
      invoicingServerData: [],
      rules: {
        serverProvider: [
          { required: true, message: "请填写电子发票服务商", trigger: "blur" },
        ],
        serverProviderUrl: [
          { required: true, message: "请填写开票地址", trigger: "blur" },
        ],
        personnelCode: [
          { required: true, message: "请填写人员代码", trigger: "blur" },
        ],
        keyCode: [{ required: true, message: "请填写公钥", trigger: "blur" }],
        serviceProvider: [
          {
            required: true,
            message: "请填写私钥",
            trigger: ["blur", "change"],
          },
        ],
        sellerName: [
          { required: true, message: "请填写销售方名称", trigger: "blur" },
        ],
        sellerTaxpayerIdentifyNumber: [
          { required: true, message: "请填写销售方税号", trigger: "blur" },
        ],
        sellerAddressPhone: [
          { required: true, message: "请填写销售方地址电话", trigger: "blur" },
        ],
        sellerBankAccount: [
          { required: true, message: "请填写销售方开户行", trigger: "blur" },
        ],
        productServiceName: [
          { required: true, message: "请填写劳务名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
      }
    },
    initInvoiceConfigure() {
      this.invoiceConfigure = {
        id: "",
        serverProvider: "",
        serverProviderUrl: "",
        personnelCode: "",
        keyCode: "",
        sellerName: "",
        sellerTaxpayerIdentifyNumber: "",
        sellerAddressPhone: "",
        sellerBankAccount: "",
        productServiceName: "",
      };
    },
    payConfigureOne() {
      this.$postRequest(invoiceConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          this.invoiceConfigure.id = data.data.id;
          this.invoiceConfigure.serverProvider = data.data.serverProvider;
          this.invoiceConfigure.serverProviderUrl = data.data.serverProviderUrl;
          this.invoiceConfigure.personnelCode = data.data.personnelCode;
          this.invoiceConfigure.keyCode = data.data.keyCode;
          this.invoiceConfigure.sellerName = data.data.sellerName;
          this.invoiceConfigure.sellerTaxpayerIdentifyNumber =
            data.data.sellerTaxpayerIdentifyNumber;
          this.invoiceConfigure.sellerAddressPhone =
            data.data.sellerAddressPhone;
          this.invoiceConfigure.sellerBankAccount = data.data.sellerBankAccount;
          this.invoiceConfigure.productServiceName =
            data.data.productServiceName;
        } else {
          this.initInvoiceConfigure();
        }
      });
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场或道路！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          if (this.invoiceConfigure.id) {
            this.$putRequest(invoiceConfigureAddOr(), {
              id: this.invoiceConfigure.id,
              parkingId: this.treeData.parkingId,
              serverProvider: this.invoiceConfigure.serverProvider,
              serverProviderUrl: this.invoiceConfigure.serverProviderUrl,
              personnelCode: this.invoiceConfigure.personnelCode,
              keyCode: this.invoiceConfigure.keyCode,
              sellerName: this.invoiceConfigure.sellerName,
              sellerTaxpayerIdentifyNumber: this.invoiceConfigure
                .sellerTaxpayerIdentifyNumber,
              sellerAddressPhone: this.invoiceConfigure.sellerAddressPhone,
              sellerBankAccount: this.invoiceConfigure.sellerBankAccount,
              productServiceName: this.invoiceConfigure.productServiceName,
            }).then((data) => {
              //提交后的操作
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "修改配置成功!",
              });
            });
          } else {
            this.$postRequest(invoiceConfigureAddOrEdit(), {
              // id: this.invoiceConfigure.id,
              parkingId: this.treeData.parkingId,
              serverProvider: this.invoiceConfigure.serverProvider,
              serverProviderUrl: this.invoiceConfigure.serverProviderUrl,
              personnelCode: this.invoiceConfigure.personnelCode,
              keyCode: this.invoiceConfigure.keyCode,
              sellerName: this.invoiceConfigure.sellerName,
              sellerTaxpayerIdentifyNumber: this.invoiceConfigure
                .sellerTaxpayerIdentifyNumber,
              sellerAddressPhone: this.invoiceConfigure.sellerAddressPhone,
              sellerBankAccount: this.invoiceConfigure.sellerBankAccount,
              productServiceName: this.invoiceConfigure.productServiceName,
            }).then((data) => {
              if (data.status != 200) return this.$layer.msg(data.message);
              this.$notify({
                type: "success",
                title: "成功",
                message: "新增配置成功!",
              });
            });
          }
        }
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场或道路！",
          type: "warning",
        });
        return;
      }
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
    invoicingServer() {
      this.$get(requestInvoicingServer()).then((data) => {
        this.invoicingServerData = data.data.rows;
    
      });
    },
  },
  created() {
    this.invoicingServer();
  },
  computed: {},
  components: {
    AllTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.submit {
  text-align: center;
}
</style>
<style>
.api-configure .el-form {
  width: 70%;
  margin: 0 auto;
  margin-top: 50px;
}
.api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.api-configure .el-form-item {
  margin-bottom: 30px;
}
.api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
</style>